export const COLOR_PRIMARY = "#2198F3";
export const COLOR_SECONDARY = "#F29F22";
export const COLOR_WHITE = "#FFFFFF";
export const COLOR_BLUE_30 = "#86C6F9";
export const COLOR_ALABASTER = "#42BE65";
export const COLOR_BLACK = "#000000";
export const COLOR_GREY_10 = "#F9F9F9";
export const COLOR_GREY_20 = "#F3F3F7";
export const COLOR_GREY_40 = "#F5F5F5";
export const COLOR_GREY_50 = "#D9D9D9";
export const COLOR_GREY_55 = "#abafb9";
export const COLOR_GREY_60 = "#6f6f6f";
export const COLOR_GREY_70 = "#8C898E";
export const COLOR_GREY_80 = "#524D57";
export const COLOR_GREY_100 = "#1F0F2F";
export const COLOR_YELLOW = "#FFCC47";
export const COLOR_AMBER = "#FFBD0F";
export const COLOR_ALIZARIN_CRIMSON = "#DE2321";
export const COLOR_ALTO = "#D8D8D8";
export const COLOR_SILVER = "#C4C4C4";
export const COLOR_BLUE_BAYOUX = "#526187";
export const COLOR_OXFORD_BLUE = "#343C53";
export const COLOR_PICKLED_BLUEWOOD = "#333B58";
export const COLOR_FIORD = "#3f4969";
export const COLOR_MARTINIQUE = "#303650";
export const COLOR_EBONY_CLAY = "#222944";
export const COLOR_WOODSMOKE = "#0e0f13";
export const COLOR_DODGER_BLUE = "#2196F3";
export const COLOR_DUSTY_GREY = "#9A9A9A";
export const COLOR_STORM_GREY = "#6B7186";
export const COLOR_RED = "#e53935";
export const COLOR_CHARTREUSE = "#76FF03";
export const TEXT_COLOR = "hsl(215, 15%, 12%)";
export const SECONDARY_TEXT_COLOR = "hsl(215, 15%, 22%)";
export const TERTIARY_TEXT_COLOR = "hsl(215, 15%, 40%)";
export const DISABLED_TEXT_COLOR = "rgba(0, 0, 0, 0.38)";
export const COLOR_WHITE_ALPHA = "rgba(255, 255, 255, 0.47)";
export const COLOR_BG_PRIMARY = COLOR_GREY_10;
export const COLOR_PRIMARY_DARKEN = "#0C7ED5";
export const COLOR_ORANGE = "#fb8c00";
export const COLOR_PURPLE = "#8e24aa";
export const COLOR_PINK = "#f06292";
